import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop } from "vue-property-decorator";
// S1
import BaseMixer from "@/router/views/BaseMixer";
import { safeUrl } from "../updatesHelpers";
/**
 * An update's uploaded documents on the timeline.
 */
let UpdateAttachments = /** @class */ (() => {
    let UpdateAttachments = class UpdateAttachments extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.safeUrl = safeUrl;
        }
        fileName(file) {
            return file.label || "Attachment";
        }
    };
    __decorate([
        Prop({ default: () => [] }),
        __metadata("design:type", Array)
    ], UpdateAttachments.prototype, "files", void 0);
    UpdateAttachments = __decorate([
        Component({
            name: "UpdateAttachments",
        })
    ], UpdateAttachments);
    return UpdateAttachments;
})();
export default UpdateAttachments;
